export default __webpack_public_path__ + "static/media/a5.5eec21f1.PNG";